import React from "react";
import { motion } from "framer-motion";
import SectionHeader from "../SectionHeader";

const STEPS = [
  {
    num: "01",
    title: "Discover",
    desc: "A 30-minute call to map your workflows, pain points, and the modules that fit.",
  },
  {
    num: "02",
    title: "Configure",
    desc: "We set up your instance, migrate your data, and tailor reports to your business.",
  },
  {
    num: "03",
    title: "Onboard",
    desc: "Role-based training for your team — most customers go live within 2–4 weeks.",
  },
  {
    num: "04",
    title: "Grow",
    desc: "Switch on new modules as you scale, with our support team a call away.",
  },
];

const HowItWorks = () => (
  <section className="section">
    <SectionHeader
      eyebrow="How it works"
      title="From first call to go-live in four steps"
      lead="A proven implementation path refined over 250+ rollouts — so you always know what happens next."
    />
    <div className="steps-grid">
      {STEPS.map((s, i) => (
        <motion.div
          key={s.num}
          className="step-card"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.45, delay: i * 0.08 }}
        >
          <div className="step-card__num">{s.num}</div>
          <h3>{s.title}</h3>
          <p>{s.desc}</p>
        </motion.div>
      ))}
    </div>
  </section>
);

export default HowItWorks;
